import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {handleEvent} from '../../../../events/event-handler';
import CaptionsNodeContainer from './captions-node';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


const getDataFromNode = function(node) {
    const keys = ['loop', 'start', 'required', 'src'];
    const nodeProps = filterNodeProperties(node, keys);
    nodeProps.start = nodeProps.start === '1';
    return nodeProps;
};

const getDataFromEventNode = function(node) { // eslint-disable-line no-unused-vars
    const keys = ['enabled', 'onaudiocomplete'];
    return filterNodeProperties(node, keys, {method: {}});
};

const getDataFromMethodNode = function(node) { // eslint-disable-line no-unused-vars
    const keys = ['enabled', 'target_type', 'name', 'target'];
    return filterNodeProperties(node, keys, {params: []});
};

const getDataFromParamNode = function(node) { // eslint-disable-line no-unused-vars
    const keys = ['title', 'name', 'value', 'data_type'];
    return filterNodeProperties(node, keys);
};

/*
An audio node may have these child nodes: event_node > method_node > param_node. I don't believe those nodes need to be
components since they need no UI. That data can become part of this class.
 */
const getEventNodeData = function(nodes) {
    const event = nodes.find(n => n.name === 'event_node');
    let method = {};
    let param = {};

    if (event) {
        method = event.children.find(n => n.name === 'method_node');
    }

    if (method.children) {
        param = method.children.find(n => n.name === 'param_node');
    }

    return { event, method, param };
};

const getStateFromProps = function (props = {}) {
    const nodeData = getDataFromNode(props.node);

    return {
        ...nodeData,
        startCaption: !!nodeData.start,
        event: getEventNodeData(props.node.children),

    };
};

class AudioNode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...getStateFromProps(props),
            preventRepeat: false, // true after a audio is played, so that we know not to replay the old audio upon playing another audio/video.
        };

        this.timesUpEvent = this.timesUp.bind(this);
        this.stop = this.stop.bind(this);
        this.start = this.start.bind(this);        

    }

    componentDidMount() {
        const {disableJREAppPlayerContainerButtons} = this.props;
        disableJREAppPlayerContainerButtons('preventMultiClick', 'componentDidMount AudioNode');
        document.addEventListener('jre-audio-times-up', this.timesUpEvent);
        document.addEventListener('stop_audio', this.stop);
        document.addEventListener('start_audio', this.start);
        // alert('pause5');        
        // if(this.mainaudio != undefined){
        // alert('pause4');        
        // this.mainaudio.pause(); 
        // }else{
        //     alert(this.mainaudio+'this.mainaudio');
        // }
        // this.mainaudio = undefined;       
        this.setState({start: true});
        this.audio.play();
    }

    componentWillUnmount() {
        const {enableJREAppPlayerContainerButtons} = this.props;
        enableJREAppPlayerContainerButtons('preventMultiClick', 'componentWillUnmount AudioNode');
        document.removeEventListener('jre-audio-times-up', this.timesUpEvent);
        document.removeEventListener('stop_audio', this.stop);
        document.removeEventListener('start_audio', this.start);                     
    }

     UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.node !== nextProps.node) {
            this.setState({
                ...getStateFromProps(nextProps)
            });
        }

        // Only play/pause one audio node - that's the audio that initially started, or one that is triggered by an event
        if ((this.props.pauseFlag !== nextProps.pauseFlag) && this.state.start) {
            if (nextProps.pauseFlag) {
                this.audio.pause();
            } else if (!this.state.preventRepeat) {
                // If there are multiple audio/videos on the same page triggered by an event,
                // preventRepeat prevents the original audio/video from replaying unexpectedly.
                this.audio.play();
            }
        }
    }

    stop(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.audio.pause();
            this.audio.currentTime = 0.0;
            this.setState({preventRepeat: true});
        }
    }

    start(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {              
            // this.audio.play();
            // setting start to true allows the pause button to work for an audio triggered by an event
            this.setState({start: true});
        }
    }

    timesUp(e) {
        /* There can be multiple audio nodes on a page and we don't want to play more than one audio at the same time.
        If the audio's "start" has a value of 1, the audio immediately started and doesn't need to be replayed here,
        otherwise, it will play in the future when triggered by an event. The audio's "required" flag may also possibly
        be used here. */
        if (!this.state.start && this.props.node.attr.id === e.detail.target) {
            this.audio.play();
        }
    }

    customstopaudio(){                           
            // console.log(this.mainaudio);
            // if(this.mainaudio != null){
            //     this.mainaudio.pause();   
            // }
            // this.mainaudio.pause();
            
            let main = localStorage.getItem('audioevent');
            const doc = new DOMParser().parseFromString(main, 'text/html');
            // console.log(doc.body.firstChild);            
            // this.mainaudio = doc.body.firstChild;
            // this.mainaudio.pause();
            // console.log('pause');
            doc.body.firstChild.setAttribute("id", "mainaudio");
            doc.body.firstChild.pause();
            doc.body.firstChild.currentTime = 0;            
            // console.log(doc.body.firstChild);
            doc.body.firstChild.removeAttribute("autoplay");
            setTimeout(()=>{
                // var a = document.getElementById("mainaudio");  
                var a = document.getElementsByTagName("audio");  
                // console.log(a[0]);
                a[0].removeAttribute("autoplay");
                a[0].pause();
                // console.log(doc.body.firstChild);
            },500)               
            // console.log(main);
            // let mains = main.outerHTML;
            // console.log(mains);
            // main.html(main);
            // main.pause();                       
    }
   
    audioPlay() {
        // alert('pause98');         
        // changeAudioStatus(true);
        // var divs = document.getElementsByTagName("audio_node");
        // console.log(divs);
        // console.log(this.props);
        // for(var i = 0; i < divs.length;i++)
        // {
        //     console.log(divs);
        // }
        // console.log(ReactDOM.findDOMNode("audio_node").parentNode.getAttribute("start"));
        // const [clicked, setClicked] = useState(false);                
        // console.log(this.props);
        if (this.props.parentNodeType === 'ce-button') { 
            this.customstopaudio();            
            /* Based on the behaviour of the original Flash slides, it looks like the audio player toggle actions
            (play and pause) are not supported when the parent of the audio node is a click event (ce) button. This
            check could also be added to audioPause() but its only necessary in this function for the "play" action. */            
            // console.log(this.state);
            // this.audio.pause();  
            // this.audio.currentTime = 0.0;
            // this.playfun();           
        //   console.log(this.state);              
          return;
      }         
        this.setState({
            startCaption: true,
            captionsNode: this.props.node.childNamed('captions_node') || null
        });
        document.dispatchEvent(new Event('jre-audio-play'));      
        // console.log(this.state); 
        
    }



    audioPause(){
        document.dispatchEvent(new Event('jre-audio-pause'));
    }

    audioEnded() {                    
        const el = document.querySelector('#overlayhide');
        // console.log(el);
        if(el != null){
           el.classList.remove("overlay-mask");
        }                
        
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function(event) {
            if (event.attr.name === 'onaudiocomplete') {
                handleEvent(event);
            }
        });
        this.setState({preventRepeat: true}, () => {
            const {enableJREAppPlayerContainerButtons} = this.props;
            enableJREAppPlayerContainerButtons('preventMultiClick', 'audioEnded AudioNode');
            document.dispatchEvent(new Event('jre-audio-ended'));
        });
    }
    check(check,audio){
        // console.log(check);    
        // console.log(this.mainaudio) ;  
        // console.log(audio);
        if (check.parentNodeType !== 'ce-button' && audio != null) {    
            // console.log('assiged');
            this.mainaudio = audio;
            // console.log(audio);            
            localStorage.setItem('audioevent',audio.outerHTML);            
        }
    }

    render() {
        const {moduleURL = ''} = this.props;
        const {src = '', loop = 0, start = false, startCaption = true, captionsNode = null} = this.state;       
        
        return (       
            <div>
                <audio controls={loop === 1} ref={(audio) => {this.check(this.props,audio);this.audio = audio;}} autoPlay={start === true}
                       onEnded={this.audioEnded.bind(this)} onPause={this.audioPause.bind(this)}
                       onPlay={this.audioPlay.bind(this)}>
                    <source src={`${moduleURL}/media/${src}`} />
                </audio>
                {(startCaption && captionsNode) ?
                    <CaptionsNodeContainer pause={this.props.pauseFlag} type="audio" key={captionsNode.attr.id}
                                           node={captionsNode}/> : ''
                }
            </div>
        );
    }
}

AudioNode.propTypes = {
    node: PropTypes.object.isRequired,
    onAudioEnd: PropTypes.func,
    event: PropTypes.object,
    parentNodeType: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        pauseFlag: state.pauseFlag,
    };
};

const AudioNodeContainer = connect(
    mapStateToProps, null
)(AudioNode);

export default withRouter(AudioNodeContainer);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/audio-node.js